<div class="wrapper">
  <div class="label">{{label}}:</div>
  <div class="value">{{value}}</div>
</div>
